__turbopack_context__.v({
  "calendar": "Calendar-module-scss-module__LhCyRW__calendar",
  "calendarHeader": "Calendar-module-scss-module__LhCyRW__calendarHeader",
});
